import { MetaInfo } from "@/components/meta-info"
import { ApiReferenceSettingsDialog } from "@/screens/app/helpCenter/api-reference-settings-dialog"
import { HelpCenterSettings } from "@/screens/app/helpCenter/help-center-settings"
import { SettingsHeader } from "../settings-header"

export function HelpCenterSettingsPage() {
	return (
		<>
			<MetaInfo title="Docs Settings" />

			<SettingsHeader
				title="Docs"
				subtitle="Publish beautiful, easy to use and maintainable docs."
				docsArticle="711a725d-dc34-4d34-8609-255364f5a33b"
			/>
			<HelpCenterSettings />
			<ApiReferenceSettingsDialog />
		</>
	)
}
